import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=290fe6db&scoped=true&lang=pug&"
import script from "./StudentPage.vue?vue&type=script&lang=js&"
export * from "./StudentPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentPage.vue?vue&type=style&index=0&id=290fe6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290fe6db",
  null
  
)

export default component.exports